import IconExclamationMarkCircle from '@fortuneo/ui-icons/pictograms/IconExclamationMarkCircle'
import React, { type FC } from 'react'

export enum MEDIA_FORMAT {
  VIDEO = 'video/mp4',
  AUDIO = 'audio/mpeg',
}

const UNSUPPORTED_MEDIA = {
  ALERT_TEXT_AUDIO:
    "Votre navigateur ne prend pas en charge l'audio, veuillez mettre à jour votre navigateur.",
  ALERT_TEXT_VIDEO: 'Votre navigateur ne prend pas en charge la vidéo.',
  ALERT_TEXT_DEFAULT: 'Votre navigateur ne prend pas en charge le média.',
}

const MESSAGE_BY_FORMAT: Utils.Object<string, MEDIA_FORMAT | string> = {
  [MEDIA_FORMAT.AUDIO]: UNSUPPORTED_MEDIA.ALERT_TEXT_AUDIO,
  [MEDIA_FORMAT.VIDEO]: UNSUPPORTED_MEDIA.ALERT_TEXT_VIDEO,
}

type Props = {
  format?: string
}

export const UnsupportedMediaMessage: FC<Props> = ({ format }) => {
  const alertMessage =
    MESSAGE_BY_FORMAT[format] || UNSUPPORTED_MEDIA.ALERT_TEXT_DEFAULT

  return (
    <div className="bg-theme-default-accent2 p-4 text-center">
      <IconExclamationMarkCircle />
      <p className="mt-2">{alertMessage}</p>
    </div>
  )
}
